import React from 'react';


class Thanks extends React.Component{
	render(){
		return (
			<div>
				<p>Thanks!
				</p>
			</div>

		);
	}
}

export default Thanks;


// WEBPACK FOOTER //
// ./src/components/Thanks.js